// src/features/notifications/notificationsApi.ts

import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'config/axiosBaseQuery';
import { endpoints } from 'config/api';
import { NotificationsResponse, NotificationsQueryParams } from './notificationsTypes';

export const notificationsApi = createApi({
  reducerPath: 'notificationsApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['Notifications'],
  endpoints: (builder) => ({
    getNotifications: builder.query<NotificationsResponse, NotificationsQueryParams | void>({
      query: (params) => {
        const queryParams = new URLSearchParams();
        if (params?.page) queryParams.append('page', params.page.toString());
        if (params?.limit) queryParams.append('limit', params.limit.toString());

        const queryString = queryParams.toString();
        return {
          url: `${endpoints.notifications.base}${queryString ? `?${queryString}` : ''}`,
          method: 'GET',
        };
      },
      providesTags: ['Notifications'],
    }),

    markAsRead: builder.mutation<void, string>({
      query: (notificationId: string) => ({
        url: endpoints.notifications.markAsRead(notificationId),
        method: 'PUT',
      }),
      invalidatesTags: ['Notifications'],
    }),

    markAllAsRead: builder.mutation<void, void>({
      query: () => ({
        url: endpoints.notifications.markAllAsRead,
        method: 'PUT',
      }),
      invalidatesTags: ['Notifications'],
    }),

    deleteNotification: builder.mutation<void, string>({
      query: (notificationId: string) => ({
        url: endpoints.notifications.delete(notificationId),
        method: 'DELETE',
      }),
      invalidatesTags: ['Notifications'],
    }),

    deleteAllNotifications: builder.mutation<void, void>({
      query: () => ({
        url: endpoints.notifications.deleteAll,
        method: 'DELETE',
      }),
      invalidatesTags: ['Notifications'],
    }),
  })
});

export const {
  useGetNotificationsQuery,
  useMarkAsReadMutation,
  useMarkAllAsReadMutation,
  useDeleteNotificationMutation,
  useDeleteAllNotificationsMutation,
} = notificationsApi;
